
import { Box, Grid } from '@mui/material';
import InputForm from "../../../InputT";
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput"
import SelectMultipleOptionBasket from "../../../SelectMultipleOptionPanier";
import CheckboxF from '../../../ChexBox';
import { useState } from 'react';
import SelectOption from '../../../SelectOption';
import InputTauxDouble from '../../../InputTauxDouble';

//pour le compte de groupe
let searchParamsMourabaha: ParamsPicklist = { CodeAgence: '', Table: "ParamsMourabaha", Colonne1: "CodeMourabaha", Colonne2: "LibelleMourabaha", Colagence: '101', Choix: 22 }
let searchOperat  : ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchWorkflow  : ParamsPicklist = { CodeAgence: 'MOURABAHA', Table: "WorkflowEtape", Colonne1: "EtapeID", Colonne2: "LibelleEtape", Colagence: 'CodeFinancement', Choix: 22 }


const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {

const  [taxable,setTaxable]=useState(true);

 const handlerchangeIsttax=()=>{
    const IsTaxable=props.form.getFieldValue("IsTaxable");
    if(IsTaxable){
        setTaxable(false);
        props.form.setFieldValue('MontantMintax',0)
    } else {
        setTaxable(true);
       props.form.setFieldValue('MontantMintax',0)
    }

   }



    return (
        <div className="tabItem">
            <Box  fontStyle="inherit"  className="border"  width={"85%"}   position={"absolute"}>
                <Box fontStyle="inherit" className="border-left">
                    <Grid container spacing={0}>
                        <Grid item xs={12} md={6}>
                            <SearInputG notRequired  dissabledCode={props.etatG} width={7} Titre="Recherche" label="Code de Mouhabara"    name="CodeMourabaha" Parametre={searchParamsMourabaha} form={props.form}    />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputForm    width={3} label="Libellé"  type="text"   name="LibelleMourabaha"  />
                        </Grid>

                        {/* Ligne 2 */}
                    
                        {/* <Grid item xs={12} md={4}>
                            <InputForm  money width={12}  label="Montant épargne requis"  type="number" name="MONTEPARG"
                            />
                        </Grid> */}
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12}  label="Montant maximum autorisé"  type="number"  name="MontantMaxAuto"/>
                        </Grid>

                     <Grid item xs={12} md={4}>
                            <InputForm  money   width={12} label="Nombre échéances Minimal" type="number" name="NbrEchMin" min={1}
                                dependencies={['NbrEchMax']}
                                rules={[
                                    ({ getFieldValue }: any) => ({
                                        validator(_: any, value: any) {
                                            if (value !== undefined && value !== null && value !== '' && Number(value) < 1) {
                                                return Promise.reject(new Error('Le nombre échéances minimal doit être supérieur ou égal à 1'));
                                            }
                                            const max = getFieldValue('NbrEchMax');
                                            if (value !== undefined && value !== null && value !== '' && max !== undefined && max !== null && max !== '' && Number(value) > Number(max)) {
                                                return Promise.reject(new Error('Le nombre échéances minimal doit être inférieur ou égal au maximum'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            />
                        </Grid>
                        {/* Ligne 3 */}
                        <Grid item xs={12} md={4}>
                            <InputForm  money   width={12} label="Nombre échéances maximum" type="number" name="NbrEchMax" min={1}
                                dependencies={['NbrEchMin']}
                                rules={[
                                    ({ getFieldValue }: any) => ({
                                        validator(_: any, value: any) {
                                            const min = getFieldValue('NbrEchMin');
                                            if (value !== undefined && value !== null && value !== '' && min !== undefined && min !== null && min !== '' && Number(value) < Number(min)) {
                                                return Promise.reject(new Error('Le nombre échéances maximum doit être supérieur ou égal au minimum'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            />
                        </Grid>
                      
                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Jours constat créance impayée"   type="number" name="JrConstatImp" />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputForm  money  width={12} label="Jours constat créance douteuse" type="number" name="JrConstatDouteux" />
                        </Grid>

                        <Grid item xs={12} md={4} display={"flex"}  alignItems={"center"}>
                              <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="IsTaxable" />
                              <InputForm disabled={taxable} notRequired money  width={8} label="Minimum Taxable" type="number" name="MontantMinTax" />
                        </Grid>

                         <Grid item xs={12} md={4}>
                            <InputForm  money  width={12} label="Nombre Maximun de Mourabaha Autorisé" type="number" name="NbrMaxAuto" />
                        </Grid>

                        <Grid item xs={12} md={4} display={"flex"}  >
                              {/* <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="Istaxable" /> */}
                              <InputForm  notRequired pourcent  width={15} label="Taux Pénalité" type="number" name="TauxP" />
                        </Grid>

                         <Grid item xs={12} md={4} display={"flex"}  >
                              {/* <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="Istaxable" /> */}
                              <InputForm  pourcent   width={8} label="Taux Marge Minimale" type="number" name="TauxMargeMin" />
                        </Grid>

                      <Grid item xs={12} md={4}>
                          <InputTauxDouble  required width={12} label="Promesse de bonne foi minimale"  name={['TauxMinPromesse', 'MontantMinPromesse']}   mode="exclusif"  />
                            {/* <InputForm  money width={12}  label="Fonds garanties"  type="number" name="FONDGARANTIE" /> */}
                    </Grid>

                        <Grid item xs={12} md={6}  >
                              {/* <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="Istaxable" /> */}
                              <SelectOption   width={8}  Size={'middle'}   label="Workflow Frais"   name="WorkflowFrais" Parametre={searchWorkflow}  />
                        </Grid>

                          <Grid item xs={12} md={4}>
                            <CheckboxF  required   width={16} label="Garantie obligatoire ?" name="IsGarantieObligatoir" />
                        </Grid>

                        {/* Ligne 4 */}
                        <Grid item xs={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <SelectMultipleOptionBasket form={props.form}  Size="large"  width={4}  label="Frais de service"  name="Frais" Parametre={searchOperat}  />
                        </Grid>

                    </Grid>
                </Box>
            </Box>
        </div>
    );
};
     


export default Tab1;